/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FeatureFlagNameEnum {
    EngageAIChat = 'EngageAI.Chat',
    EngageAIComparison = 'EngageAI.Comparison',
    EngageAIKoLab = 'EngageAI.KoLab',
    CustomerShowComparison = 'Customer.ShowComparison',
    AuthEnableUserPass = 'Auth.EnableUserPass',
    AuthEnableAzureSSO = 'Auth.EnableAzureSSO',
    EngageAISurveyDrafting = 'EngageAI.SurveyDrafting',
    CustomerProgramEvaluation = 'Customer.ProgramEvaluation',
    CustomerProgramEvaluationManualRefresh = 'Customer.ProgramEvaluation.ManualRefresh'
}

